/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermosDeUsoRouteImport } from './routes/termos-de-uso'
import { Route as SobreNosRouteImport } from './routes/sobre-nos'
import { Route as ProdutosRouteImport } from './routes/produtos'
import { Route as PoliticaDePrivacidadeRouteImport } from './routes/politica-de-privacidade'
import { Route as OrcamentoRouteImport } from './routes/orcamento'
import { Route as ContatoRouteImport } from './routes/contato'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogPostIdRouteImport } from './routes/blog.$postId'

const TermosDeUsoRoute = TermosDeUsoRouteImport.update({
  id: '/termos-de-uso',
  path: '/termos-de-uso',
  getParentRoute: () => rootRouteImport,
} as any)
const SobreNosRoute = SobreNosRouteImport.update({
  id: '/sobre-nos',
  path: '/sobre-nos',
  getParentRoute: () => rootRouteImport,
} as any)
const ProdutosRoute = ProdutosRouteImport.update({
  id: '/produtos',
  path: '/produtos',
  getParentRoute: () => rootRouteImport,
} as any)
const PoliticaDePrivacidadeRoute = PoliticaDePrivacidadeRouteImport.update({
  id: '/politica-de-privacidade',
  path: '/politica-de-privacidade',
  getParentRoute: () => rootRouteImport,
} as any)
const OrcamentoRoute = OrcamentoRouteImport.update({
  id: '/orcamento',
  path: '/orcamento',
  getParentRoute: () => rootRouteImport,
} as any)
const ContatoRoute = ContatoRouteImport.update({
  id: '/contato',
  path: '/contato',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogRoute = BlogRouteImport.update({
  id: '/blog',
  path: '/blog',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogIndexRoute = BlogIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BlogRoute,
} as any)
const BlogPostIdRoute = BlogPostIdRouteImport.update({
  id: '/$postId',
  path: '/$postId',
  getParentRoute: () => BlogRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/blog': typeof BlogRouteWithChildren
  '/contato': typeof ContatoRoute
  '/orcamento': typeof OrcamentoRoute
  '/politica-de-privacidade': typeof PoliticaDePrivacidadeRoute
  '/produtos': typeof ProdutosRoute
  '/sobre-nos': typeof SobreNosRoute
  '/termos-de-uso': typeof TermosDeUsoRoute
  '/blog/$postId': typeof BlogPostIdRoute
  '/blog/': typeof BlogIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/contato': typeof ContatoRoute
  '/orcamento': typeof OrcamentoRoute
  '/politica-de-privacidade': typeof PoliticaDePrivacidadeRoute
  '/produtos': typeof ProdutosRoute
  '/sobre-nos': typeof SobreNosRoute
  '/termos-de-uso': typeof TermosDeUsoRoute
  '/blog/$postId': typeof BlogPostIdRoute
  '/blog': typeof BlogIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/blog': typeof BlogRouteWithChildren
  '/contato': typeof ContatoRoute
  '/orcamento': typeof OrcamentoRoute
  '/politica-de-privacidade': typeof PoliticaDePrivacidadeRoute
  '/produtos': typeof ProdutosRoute
  '/sobre-nos': typeof SobreNosRoute
  '/termos-de-uso': typeof TermosDeUsoRoute
  '/blog/$postId': typeof BlogPostIdRoute
  '/blog/': typeof BlogIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/blog'
    | '/contato'
    | '/orcamento'
    | '/politica-de-privacidade'
    | '/produtos'
    | '/sobre-nos'
    | '/termos-de-uso'
    | '/blog/$postId'
    | '/blog/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/contato'
    | '/orcamento'
    | '/politica-de-privacidade'
    | '/produtos'
    | '/sobre-nos'
    | '/termos-de-uso'
    | '/blog/$postId'
    | '/blog'
  id:
    | '__root__'
    | '/'
    | '/blog'
    | '/contato'
    | '/orcamento'
    | '/politica-de-privacidade'
    | '/produtos'
    | '/sobre-nos'
    | '/termos-de-uso'
    | '/blog/$postId'
    | '/blog/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BlogRoute: typeof BlogRouteWithChildren
  ContatoRoute: typeof ContatoRoute
  OrcamentoRoute: typeof OrcamentoRoute
  PoliticaDePrivacidadeRoute: typeof PoliticaDePrivacidadeRoute
  ProdutosRoute: typeof ProdutosRoute
  SobreNosRoute: typeof SobreNosRoute
  TermosDeUsoRoute: typeof TermosDeUsoRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/termos-de-uso': {
      id: '/termos-de-uso'
      path: '/termos-de-uso'
      fullPath: '/termos-de-uso'
      preLoaderRoute: typeof TermosDeUsoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sobre-nos': {
      id: '/sobre-nos'
      path: '/sobre-nos'
      fullPath: '/sobre-nos'
      preLoaderRoute: typeof SobreNosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/produtos': {
      id: '/produtos'
      path: '/produtos'
      fullPath: '/produtos'
      preLoaderRoute: typeof ProdutosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/politica-de-privacidade': {
      id: '/politica-de-privacidade'
      path: '/politica-de-privacidade'
      fullPath: '/politica-de-privacidade'
      preLoaderRoute: typeof PoliticaDePrivacidadeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orcamento': {
      id: '/orcamento'
      path: '/orcamento'
      fullPath: '/orcamento'
      preLoaderRoute: typeof OrcamentoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contato': {
      id: '/contato'
      path: '/contato'
      fullPath: '/contato'
      preLoaderRoute: typeof ContatoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog': {
      id: '/blog'
      path: '/blog'
      fullPath: '/blog'
      preLoaderRoute: typeof BlogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/': {
      id: '/blog/'
      path: '/'
      fullPath: '/blog/'
      preLoaderRoute: typeof BlogIndexRouteImport
      parentRoute: typeof BlogRoute
    }
    '/blog/$postId': {
      id: '/blog/$postId'
      path: '/$postId'
      fullPath: '/blog/$postId'
      preLoaderRoute: typeof BlogPostIdRouteImport
      parentRoute: typeof BlogRoute
    }
  }
}

interface BlogRouteChildren {
  BlogPostIdRoute: typeof BlogPostIdRoute
  BlogIndexRoute: typeof BlogIndexRoute
}

const BlogRouteChildren: BlogRouteChildren = {
  BlogPostIdRoute: BlogPostIdRoute,
  BlogIndexRoute: BlogIndexRoute,
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BlogRoute: BlogRouteWithChildren,
  ContatoRoute: ContatoRoute,
  OrcamentoRoute: OrcamentoRoute,
  PoliticaDePrivacidadeRoute: PoliticaDePrivacidadeRoute,
  ProdutosRoute: ProdutosRoute,
  SobreNosRoute: SobreNosRoute,
  TermosDeUsoRoute: TermosDeUsoRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
